import styled from 'styled-components';
import ChaOnb01D from 'dc/ChaOnb01D';

type TutorialWrapperProps = {
  $highlight?: boolean;
};

export const TutorialWrapper = styled.div<TutorialWrapperProps>`
  pointer-events: auto;
  position: relative;
  left: 0;
  box-shadow: ${props =>
    props.$highlight
      ? '0 0 0 calc(1000vh + 100vw) rgba(0, 0, 0, 0.5)'
      : 'none'};
  z-index: ${props => (props.$highlight ? '100000' : '2')};
`;

export const PopUp01 = styled(ChaOnb01D)`
  position: absolute;
  bottom: 150px;
  left: -18px;
`;

export const PopUp02 = styled(ChaOnb01D)`
  position: absolute;
  top: 70px;
  right: 2px;
  pointer-events: auto;
  z-index: 100000;
`;
